import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { HashLoader } from "react-spinners";
import "moment/locale/th";
import * as userApi from "../../../service/userApi";
import { splitBirthday } from "../../../utils/utils";

import { CurrentUserContext } from "../../../App";

function LoginMohPromt() {
  const { role } = useParams();

  const { userRole, setUserRole, setIsMessage } =
    useContext(CurrentUserContext);

  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    getParameter();
  }, []);

  const getParameter = () => {
    let url = decodeURIComponent(window.location.href);
    let newUrl = new URL(url);
    let data = newUrl.searchParams;

    if (data.get("code") && role) {
      loginMohPromt(data.get("code"), role);
    } else {
      setIsMessage({ type: "warning", data: "code is require." });
    }
  };

  const loginMohPromt = async (code, roleName) => {
    setLoading(true);
    let res = await userApi.loginMohPromt(code, roleName);
    setLoading(false);
    console.log(res);
    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({ type: "success", data: "login success" });
        logedIn(res["data"]);
      } else if (res["data"]["code"] === 404) {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || "ไม่พบข้อมูลผู้ใช้งาน กรุณาสมัครใช้งานก่อน",
        });
        let data = res["data"]["mohpromt_user_data"] || {};
        nav("/register", {
          state: {
            type: "register_mohpromt",
            pname: data["pname"],
            fname: data["fname"],
            lname: data["lname"],
            pid: data["pid"],
            phoneNumber: data["phone_number"],
            mohpromtId: data["mohpromt_account_id"],
            access_token: data["access_token"],
            role: data["role"],
            ...splitBirthday(data["birthday"]),
          },
        });
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
        nav("/login");
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
      nav("/login");
    }
  };

  const logedIn = (data) => {
    localStorage.setItem(
      "pg_access_token",
      data["user_data"]["auth"]["access_token"],
    );
    localStorage.setItem(
      "expire_login_user",
      data["user_data"]["auth"]["access_token_expire"],
    );
    localStorage.setItem("user", JSON.stringify(data["user_data"]));

    setUserRole(data["user_data"]);

    if (data.user_data.auth.role[0] === "MEDICAL_PERSONNEL") {
      nav("/doctor/guideline");
    } else if (data.user_data.auth.role[0] === "HOSPITAL_PERSONNEL") {
      nav("/");
    } else if (data.user_data.auth.role[0] === "LABORATORY_ADMIN") {
      nav("/inputdata");
    } else if (data.user_data.auth.role[0] === "LABORATORY_PERSONNEL") {
      nav("/inputdata");
    } else if (data.user_data.auth.role[0] === "PATIENT") {
      nav("/");
    } else if (data.user_data.auth.role[0] === "ADMIN") {
      nav("/admin");
    } else if (data.user_data.auth.role[0] === "EXECUTIVE") {
      nav("/manager/aggregateResult");
    } else if (data.user_data.auth.role[0] === "HOSPITAL") {
      nav("/hospital/setting");
    } else {
      // console.log("ยังไม่ได้ทำfunction check role user");
    }
  };

  return (
    <div className="global-page h-[80vh]">
      <HashLoader
        loading={loading}
        style={{ display: "flex", justifyContent: "center" }}
        color="#FF9768"
      />
    </div>
  );
}

export default LoginMohPromt;
